import { ReactElement } from 'react'
import { useSearchParams } from 'react-router-dom'
import Pagination from '@10xLabs/react-web/components/Pagination'
import { PaginationCaption } from 'features/App/components/PaginationCaption'

import { mapFiltersToSearchQueryString } from 'features/Drivers/utils'
import { IDriversFiltersForm } from 'features/Drivers/types'

interface DriversListPaginationProps {
  filters: IDriversFiltersForm
  page: number
  limit: number
  totalItems: number
  currentItemsCount: number
}

const DriversListPagination = ({
  page,
  limit,
  totalItems,
  currentItemsCount,
  filters
}: DriversListPaginationProps): ReactElement => {
  const [, setSearchParams] = useSearchParams()

  const setPage = (page: number): void => {
    setSearchParams(mapFiltersToSearchQueryString(filters, page))
  }

  return (
    <Pagination.Container>
      <Pagination.Caption
        page={page}
        totalItems={totalItems}
        currentItemsCount={currentItemsCount}
        limit={limit}
        getCaptionMessage={(firstItemIndex: number, lastItemIndex: number): ReactElement => (
          <PaginationCaption firstItemIndex={firstItemIndex} lastItemIndex={lastItemIndex} totalItems={totalItems} />
        )}
      />
      <Pagination.Previous page={page} setPage={setPage} />
      <Pagination.Next page={page} totalItems={totalItems} limit={limit} setPage={setPage} />
    </Pagination.Container>
  )
}

export default DriversListPagination
